import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment/moment";
import api from "../client";

const BASE_URL = "identity/role";

export const getRoles = createAsyncThunk(
  "Role/list",
  async (_, { getState, rejectWithValue }) => {
    const { lastFetch } = getState().roles;
    if (moment().diff(moment(lastFetch), "minutes") < 20)
      return rejectWithValue("Roles already present in memory.");
    return (await api.get(BASE_URL)).data;
  },
);

export const getRole = createAsyncThunk(
  "Role",
  async (id) => (await api.get(`${BASE_URL}/${id}`)).data,
);

export const saveRole = createAsyncThunk(
  "Role/save",
  async (role) => (await api.post(BASE_URL, role)).data,
);

export const updateRole = createAsyncThunk(
  "Role/update",
  async (role) => (await api.put(`${BASE_URL}/${role.id}`, role)).data,
);

const addCases = (builder, thunk, onFulfilled) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      state.isSucceed = false;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSucceed = action.payload.succeeded;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSucceed = false;
      state.message = action.payload;
    });

const initialState = {
  list: [],
  role: null,
  isLoading: false,
  isSucceed: false,
  message: null,
  lastFetch: null,
};

const slice = createSlice({
  name: "roles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCases(builder, getRoles, (state, action) => {
      state.list = action.payload.data;
      state.lastFetch = Date.now();
    });
    addCases(builder, getRole, (state, action) => {
      state.role = action.payload.data;
    });
    addCases(builder, saveRole, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, updateRole, (state, action) => {
      state.message = action.payload.message;
    });
  },
});

export default slice.reducer;
